// extracted by mini-css-extract-plugin
export default {"main":"none_main__Qir5R"};